import React, { useState } from 'react';
import DocumentsSection from './knowledge-base/DocumentsSection';
import QASection from './knowledge-base/QASection';
import './KnowledgeBase.css';

interface KnowledgeBaseProps {
  projectId: string;
}

type TabType = 'documents' | 'qa';

const KnowledgeBase: React.FC<KnowledgeBaseProps> = ({ projectId }) => {
  const [activeTab, setActiveTab] = useState<TabType>('documents');

  return (
    <div className="knowledge-base">
      <div className="kb-header">
        <h2>📚 Knowledge Base</h2>
        <p className="kb-description">
          Manage your compliance knowledge repository. Upload policy documents and previous Q&A responses
          to help the AI answer questionnaires accurately.
        </p>
      </div>

      <div className="kb-tabs">
        <button
          className={`kb-tab ${activeTab === 'documents' ? 'active' : ''}`}
          onClick={() => setActiveTab('documents')}
        >
          📄 Policy Documents
        </button>
        <button
          className={`kb-tab ${activeTab === 'qa' ? 'active' : ''}`}
          onClick={() => setActiveTab('qa')}
        >
          💬 Previous Q&A
        </button>
      </div>

      <div className="kb-content">
        {activeTab === 'documents' && (
          <div className="kb-panel">
            <DocumentsSection projectId={projectId} />
          </div>
        )}
        {activeTab === 'qa' && (
          <div className="kb-panel">
            <QASection projectId={projectId} />
          </div>
        )}
      </div>
    </div>
  );
};

export default KnowledgeBase;

